function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _min from "lodash/min";
import _map from "lodash/map";

var _templateObject;

function cov_z2w099oc0() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/ProgressBar/ProgressBar.tsx";
  var hash = "a0b917a27b6fe13385e03ad851c6dd082e2fbb93";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/ProgressBar/ProgressBar.tsx",
    statementMap: {
      "0": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 26
        }
      },
      "1": {
        start: {
          line: 43,
          column: 37
        },
        end: {
          line: 43,
          column: 38
        }
      },
      "2": {
        start: {
          line: 44,
          column: 33
        },
        end: {
          line: 44,
          column: 34
        }
      },
      "3": {
        start: {
          line: 46,
          column: 24
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "4": {
        start: {
          line: 58,
          column: 48
        },
        end: {
          line: 68,
          column: 3
        }
      },
      "5": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 18
        }
      },
      "6": {
        start: {
          line: 82,
          column: 21
        },
        end: {
          line: 82,
          column: 39
        }
      },
      "7": {
        start: {
          line: 83,
          column: 21
        },
        end: {
          line: 83,
          column: 44
        }
      },
      "8": {
        start: {
          line: 85,
          column: 23
        },
        end: {
          line: 86,
          column: 86
        }
      },
      "9": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 86
        }
      },
      "10": {
        start: {
          line: 89,
          column: 26
        },
        end: {
          line: 89,
          column: 27
        }
      },
      "11": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 96,
          column: 5
        }
      },
      "12": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 95,
          column: 10
        }
      },
      "13": {
        start: {
          line: 92,
          column: 34
        },
        end: {
          line: 92,
          column: 96
        }
      },
      "14": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 141,
          column: 6
        }
      },
      "15": {
        start: {
          line: 145,
          column: 25
        },
        end: {
          line: 145,
          column: 35
        }
      },
      "16": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 62
        }
      },
      "17": {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 156,
          column: 16
        }
      },
      "18": {
        start: {
          line: 158,
          column: 21
        },
        end: {
          line: 158,
          column: 39
        }
      },
      "19": {
        start: {
          line: 159,
          column: 24
        },
        end: {
          line: 159,
          column: 70
        }
      },
      "20": {
        start: {
          line: 160,
          column: 25
        },
        end: {
          line: 160,
          column: 27
        }
      },
      "21": {
        start: {
          line: 161,
          column: 37
        },
        end: {
          line: 161,
          column: 39
        }
      },
      "22": {
        start: {
          line: 162,
          column: 38
        },
        end: {
          line: 162,
          column: 40
        }
      },
      "23": {
        start: {
          line: 164,
          column: 15
        },
        end: {
          line: 164,
          column: 55
        }
      },
      "24": {
        start: {
          line: 165,
          column: 16
        },
        end: {
          line: 165,
          column: 25
        }
      },
      "25": {
        start: {
          line: 166,
          column: 20
        },
        end: {
          line: 166,
          column: 38
        }
      },
      "26": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 178,
          column: 5
        }
      },
      "27": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 177,
          column: 7
        }
      },
      "28": {
        start: {
          line: 169,
          column: 8
        },
        end: {
          line: 169,
          column: 30
        }
      },
      "29": {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 170,
          column: 53
        }
      },
      "30": {
        start: {
          line: 171,
          column: 13
        },
        end: {
          line: 177,
          column: 7
        }
      },
      "31": {
        start: {
          line: 172,
          column: 8
        },
        end: {
          line: 172,
          column: 25
        }
      },
      "32": {
        start: {
          line: 173,
          column: 8
        },
        end: {
          line: 175,
          column: 12
        }
      },
      "33": {
        start: {
          line: 176,
          column: 8
        },
        end: {
          line: 176,
          column: 52
        }
      },
      "34": {
        start: {
          line: 179,
          column: 31
        },
        end: {
          line: 179,
          column: 64
        }
      },
      "35": {
        start: {
          line: 180,
          column: 30
        },
        end: {
          line: 180,
          column: 62
        }
      },
      "36": {
        start: {
          line: 181,
          column: 24
        },
        end: {
          line: 181,
          column: 69
        }
      },
      "37": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 217,
          column: 6
        }
      },
      "38": {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 227,
          column: 18
        }
      },
      "39": {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 282,
          column: 6
        }
      },
      "40": {
        start: {
          line: 231,
          column: 25
        },
        end: {
          line: 231,
          column: 59
        }
      },
      "41": {
        start: {
          line: 232,
          column: 10
        },
        end: {
          line: 279,
          column: 12
        }
      },
      "42": {
        start: {
          line: 242,
          column: 49
        },
        end: {
          line: 242,
          column: 77
        }
      },
      "43": {
        start: {
          line: 286,
          column: 43
        },
        end: {
          line: 286,
          column: 53
        }
      },
      "44": {
        start: {
          line: 288,
          column: 4
        },
        end: {
          line: 290,
          column: 5
        }
      },
      "45": {
        start: {
          line: 289,
          column: 6
        },
        end: {
          line: 289,
          column: 35
        }
      },
      "46": {
        start: {
          line: 292,
          column: 18
        },
        end: {
          line: 292,
          column: 36
        }
      },
      "47": {
        start: {
          line: 294,
          column: 14
        },
        end: {
          line: 294,
          column: 91
        }
      },
      "48": {
        start: {
          line: 295,
          column: 14
        },
        end: {
          line: 295,
          column: 91
        }
      },
      "49": {
        start: {
          line: 296,
          column: 14
        },
        end: {
          line: 296,
          column: 91
        }
      },
      "50": {
        start: {
          line: 298,
          column: 4
        },
        end: {
          line: 298,
          column: 42
        }
      },
      "51": {
        start: {
          line: 302,
          column: 27
        },
        end: {
          line: 302,
          column: 51
        }
      },
      "52": {
        start: {
          line: 303,
          column: 20
        },
        end: {
          line: 303,
          column: 22
        }
      },
      "53": {
        start: {
          line: 304,
          column: 20
        },
        end: {
          line: 304,
          column: 71
        }
      },
      "54": {
        start: {
          line: 305,
          column: 4
        },
        end: {
          line: 305,
          column: 19
        }
      },
      "55": {
        start: {
          line: 309,
          column: 19
        },
        end: {
          line: 309,
          column: 53
        }
      },
      "56": {
        start: {
          line: 310,
          column: 4
        },
        end: {
          line: 312,
          column: 5
        }
      },
      "57": {
        start: {
          line: 311,
          column: 6
        },
        end: {
          line: 311,
          column: 42
        }
      },
      "58": {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 315,
          column: 5
        }
      },
      "59": {
        start: {
          line: 314,
          column: 6
        },
        end: {
          line: 314,
          column: 38
        }
      },
      "60": {
        start: {
          line: 316,
          column: 4
        },
        end: {
          line: 316,
          column: 13
        }
      },
      "61": {
        start: {
          line: 320,
          column: 25
        },
        end: {
          line: 320,
          column: 35
        }
      },
      "62": {
        start: {
          line: 321,
          column: 4
        },
        end: {
          line: 323,
          column: 5
        }
      },
      "63": {
        start: {
          line: 322,
          column: 6
        },
        end: {
          line: 322,
          column: 25
        }
      },
      "64": {
        start: {
          line: 324,
          column: 4
        },
        end: {
          line: 326,
          column: 5
        }
      },
      "65": {
        start: {
          line: 325,
          column: 6
        },
        end: {
          line: 325,
          column: 27
        }
      },
      "66": {
        start: {
          line: 327,
          column: 4
        },
        end: {
          line: 327,
          column: 21
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        loc: {
          start: {
            line: 70,
            column: 18
          },
          end: {
            line: 142,
            column: 3
          }
        },
        line: 70
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 85,
            column: 23
          },
          end: {
            line: 85,
            column: 24
          }
        },
        loc: {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 86,
            column: 86
          }
        },
        line: 86
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 92,
            column: 27
          },
          end: {
            line: 92,
            column: 28
          }
        },
        loc: {
          start: {
            line: 92,
            column: 34
          },
          end: {
            line: 92,
            column: 96
          }
        },
        line: 92
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 144,
            column: 2
          },
          end: {
            line: 144,
            column: 3
          }
        },
        loc: {
          start: {
            line: 144,
            column: 24
          },
          end: {
            line: 147,
            column: 3
          }
        },
        line: 144
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 149,
            column: 2
          },
          end: {
            line: 149,
            column: 3
          }
        },
        loc: {
          start: {
            line: 154,
            column: 4
          },
          end: {
            line: 218,
            column: 3
          }
        },
        line: 154
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 220,
            column: 2
          },
          end: {
            line: 220,
            column: 3
          }
        },
        loc: {
          start: {
            line: 220,
            column: 29
          },
          end: {
            line: 283,
            column: 3
          }
        },
        line: 220
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 230,
            column: 25
          },
          end: {
            line: 230,
            column: 26
          }
        },
        loc: {
          start: {
            line: 230,
            column: 43
          },
          end: {
            line: 280,
            column: 9
          }
        },
        line: 230
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 242,
            column: 43
          },
          end: {
            line: 242,
            column: 44
          }
        },
        loc: {
          start: {
            line: 242,
            column: 49
          },
          end: {
            line: 242,
            column: 77
          }
        },
        line: 242
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 285,
            column: 2
          },
          end: {
            line: 285,
            column: 3
          }
        },
        loc: {
          start: {
            line: 285,
            column: 39
          },
          end: {
            line: 299,
            column: 3
          }
        },
        line: 285
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 301,
            column: 2
          },
          end: {
            line: 301,
            column: 3
          }
        },
        loc: {
          start: {
            line: 301,
            column: 23
          },
          end: {
            line: 306,
            column: 3
          }
        },
        line: 301
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 308,
            column: 2
          },
          end: {
            line: 308,
            column: 3
          }
        },
        loc: {
          start: {
            line: 308,
            column: 50
          },
          end: {
            line: 317,
            column: 3
          }
        },
        line: 308
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 319,
            column: 2
          },
          end: {
            line: 319,
            column: 3
          }
        },
        loc: {
          start: {
            line: 319,
            column: 69
          },
          end: {
            line: 328,
            column: 3
          }
        },
        line: 319
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 90
      },
      "1": {
        loc: {
          start: {
            line: 92,
            column: 34
          },
          end: {
            line: 92,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 34
          },
          end: {
            line: 92,
            column: 62
          }
        }, {
          start: {
            line: 92,
            column: 66
          },
          end: {
            line: 92,
            column: 96
          }
        }],
        line: 92
      },
      "2": {
        loc: {
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 101,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 101,
            column: 43
          },
          end: {
            line: 101,
            column: 50
          }
        }, {
          start: {
            line: 101,
            column: 53
          },
          end: {
            line: 101,
            column: 63
          }
        }],
        line: 101
      },
      "3": {
        loc: {
          start: {
            line: 104,
            column: 10
          },
          end: {
            line: 104,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 104,
            column: 46
          },
          end: {
            line: 104,
            column: 56
          }
        }, {
          start: {
            line: 104,
            column: 59
          },
          end: {
            line: 104,
            column: 66
          }
        }],
        line: 104
      },
      "4": {
        loc: {
          start: {
            line: 106,
            column: 32
          },
          end: {
            line: 106,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 66
          },
          end: {
            line: 106,
            column: 67
          }
        }, {
          start: {
            line: 106,
            column: 70
          },
          end: {
            line: 106,
            column: 79
          }
        }],
        line: 106
      },
      "5": {
        loc: {
          start: {
            line: 108,
            column: 10
          },
          end: {
            line: 108,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 108,
            column: 43
          },
          end: {
            line: 108,
            column: 44
          }
        }, {
          start: {
            line: 108,
            column: 47
          },
          end: {
            line: 108,
            column: 56
          }
        }],
        line: 108
      },
      "6": {
        loc: {
          start: {
            line: 111,
            column: 10
          },
          end: {
            line: 111,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 44
          },
          end: {
            line: 111,
            column: 45
          }
        }, {
          start: {
            line: 111,
            column: 48
          },
          end: {
            line: 111,
            column: 57
          }
        }],
        line: 111
      },
      "7": {
        loc: {
          start: {
            line: 117,
            column: 9
          },
          end: {
            line: 117,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 117,
            column: 9
          },
          end: {
            line: 117,
            column: 19
          }
        }, {
          start: {
            line: 117,
            column: 23
          },
          end: {
            line: 117,
            column: 57
          }
        }],
        line: 117
      },
      "8": {
        loc: {
          start: {
            line: 139,
            column: 9
          },
          end: {
            line: 139,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 9
          },
          end: {
            line: 139,
            column: 19
          }
        }, {
          start: {
            line: 139,
            column: 23
          },
          end: {
            line: 139,
            column: 46
          }
        }],
        line: 139
      },
      "9": {
        loc: {
          start: {
            line: 146,
            column: 11
          },
          end: {
            line: 146,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 146,
            column: 28
          },
          end: {
            line: 146,
            column: 31
          }
        }, {
          start: {
            line: 146,
            column: 34
          },
          end: {
            line: 146,
            column: 61
          }
        }],
        line: 146
      },
      "10": {
        loc: {
          start: {
            line: 146,
            column: 34
          },
          end: {
            line: 146,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 146,
            column: 49
          },
          end: {
            line: 146,
            column: 50
          }
        }, {
          start: {
            line: 146,
            column: 53
          },
          end: {
            line: 146,
            column: 61
          }
        }],
        line: 146
      },
      "11": {
        loc: {
          start: {
            line: 159,
            column: 24
          },
          end: {
            line: 159,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 24
          },
          end: {
            line: 159,
            column: 43
          }
        }, {
          start: {
            line: 159,
            column: 47
          },
          end: {
            line: 159,
            column: 70
          }
        }],
        line: 159
      },
      "12": {
        loc: {
          start: {
            line: 164,
            column: 18
          },
          end: {
            line: 164,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 18
          },
          end: {
            line: 164,
            column: 40
          }
        }, {
          start: {
            line: 164,
            column: 44
          },
          end: {
            line: 164,
            column: 52
          }
        }],
        line: 164
      },
      "13": {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 178,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 178,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 167
      },
      "14": {
        loc: {
          start: {
            line: 168,
            column: 6
          },
          end: {
            line: 177,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 168,
            column: 6
          },
          end: {
            line: 177,
            column: 7
          }
        }, {
          start: {
            line: 171,
            column: 13
          },
          end: {
            line: 177,
            column: 7
          }
        }],
        line: 168
      },
      "15": {
        loc: {
          start: {
            line: 171,
            column: 13
          },
          end: {
            line: 177,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 13
          },
          end: {
            line: 177,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 171
      },
      "16": {
        loc: {
          start: {
            line: 174,
            column: 31
          },
          end: {
            line: 174,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 174,
            column: 38
          },
          end: {
            line: 174,
            column: 63
          }
        }, {
          start: {
            line: 174,
            column: 66
          },
          end: {
            line: 174,
            column: 90
          }
        }],
        line: 174
      },
      "17": {
        loc: {
          start: {
            line: 181,
            column: 24
          },
          end: {
            line: 181,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 181,
            column: 31
          },
          end: {
            line: 181,
            column: 49
          }
        }, {
          start: {
            line: 181,
            column: 52
          },
          end: {
            line: 181,
            column: 69
          }
        }],
        line: 181
      },
      "18": {
        loc: {
          start: {
            line: 191,
            column: 22
          },
          end: {
            line: 191,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 191,
            column: 39
          },
          end: {
            line: 191,
            column: 47
          }
        }, {
          start: {
            line: 191,
            column: 50
          },
          end: {
            line: 191,
            column: 58
          }
        }],
        line: 191
      },
      "19": {
        loc: {
          start: {
            line: 195,
            column: 15
          },
          end: {
            line: 195,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 195,
            column: 29
          },
          end: {
            line: 195,
            column: 36
          }
        }, {
          start: {
            line: 195,
            column: 39
          },
          end: {
            line: 195,
            column: 45
          }
        }],
        line: 195
      },
      "20": {
        loc: {
          start: {
            line: 212,
            column: 21
          },
          end: {
            line: 212,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 212,
            column: 36
          },
          end: {
            line: 212,
            column: 64
          }
        }, {
          start: {
            line: 212,
            column: 67
          },
          end: {
            line: 212,
            column: 85
          }
        }],
        line: 212
      },
      "21": {
        loc: {
          start: {
            line: 213,
            column: 15
          },
          end: {
            line: 213,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 213,
            column: 29
          },
          end: {
            line: 213,
            column: 36
          }
        }, {
          start: {
            line: 213,
            column: 39
          },
          end: {
            line: 213,
            column: 45
          }
        }],
        line: 213
      },
      "22": {
        loc: {
          start: {
            line: 214,
            column: 19
          },
          end: {
            line: 214,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 214,
            column: 19
          },
          end: {
            line: 214,
            column: 41
          }
        }, {
          start: {
            line: 214,
            column: 45
          },
          end: {
            line: 214,
            column: 53
          }
        }],
        line: 214
      },
      "23": {
        loc: {
          start: {
            line: 241,
            column: 22
          },
          end: {
            line: 241,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 241,
            column: 42
          },
          end: {
            line: 241,
            column: 51
          }
        }, {
          start: {
            line: 241,
            column: 54
          },
          end: {
            line: 241,
            column: 63
          }
        }],
        line: 241
      },
      "24": {
        loc: {
          start: {
            line: 242,
            column: 23
          },
          end: {
            line: 242,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 242,
            column: 43
          },
          end: {
            line: 242,
            column: 77
          }
        }, {
          start: {
            line: 242,
            column: 80
          },
          end: {
            line: 242,
            column: 89
          }
        }],
        line: 242
      },
      "25": {
        loc: {
          start: {
            line: 249,
            column: 18
          },
          end: {
            line: 253,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 250,
            column: 22
          },
          end: {
            line: 250,
            column: 90
          }
        }, {
          start: {
            line: 251,
            column: 22
          },
          end: {
            line: 253,
            column: 33
          }
        }],
        line: 249
      },
      "26": {
        loc: {
          start: {
            line: 250,
            column: 22
          },
          end: {
            line: 250,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 250,
            column: 22
          },
          end: {
            line: 250,
            column: 41
          }
        }, {
          start: {
            line: 250,
            column: 45
          },
          end: {
            line: 250,
            column: 90
          }
        }],
        line: 250
      },
      "27": {
        loc: {
          start: {
            line: 251,
            column: 22
          },
          end: {
            line: 253,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 252,
            column: 22
          },
          end: {
            line: 252,
            column: 67
          }
        }, {
          start: {
            line: 253,
            column: 22
          },
          end: {
            line: 253,
            column: 33
          }
        }],
        line: 251
      },
      "28": {
        loc: {
          start: {
            line: 257,
            column: 18
          },
          end: {
            line: 261,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 258,
            column: 22
          },
          end: {
            line: 258,
            column: 33
          }
        }, {
          start: {
            line: 259,
            column: 22
          },
          end: {
            line: 261,
            column: 67
          }
        }],
        line: 257
      },
      "29": {
        loc: {
          start: {
            line: 259,
            column: 22
          },
          end: {
            line: 261,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 260,
            column: 22
          },
          end: {
            line: 260,
            column: 34
          }
        }, {
          start: {
            line: 261,
            column: 22
          },
          end: {
            line: 261,
            column: 67
          }
        }],
        line: 259
      },
      "30": {
        loc: {
          start: {
            line: 264,
            column: 18
          },
          end: {
            line: 266,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 265,
            column: 22
          },
          end: {
            line: 265,
            column: 50
          }
        }, {
          start: {
            line: 266,
            column: 22
          },
          end: {
            line: 266,
            column: 54
          }
        }],
        line: 264
      },
      "31": {
        loc: {
          start: {
            line: 274,
            column: 23
          },
          end: {
            line: 274,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 274,
            column: 50
          },
          end: {
            line: 274,
            column: 59
          }
        }, {
          start: {
            line: 274,
            column: 62
          },
          end: {
            line: 274,
            column: 74
          }
        }],
        line: 274
      },
      "32": {
        loc: {
          start: {
            line: 288,
            column: 4
          },
          end: {
            line: 290,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 288,
            column: 4
          },
          end: {
            line: 290,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 288
      },
      "33": {
        loc: {
          start: {
            line: 304,
            column: 20
          },
          end: {
            line: 304,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 304,
            column: 47
          },
          end: {
            line: 304,
            column: 61
          }
        }, {
          start: {
            line: 304,
            column: 64
          },
          end: {
            line: 304,
            column: 71
          }
        }],
        line: 304
      },
      "34": {
        loc: {
          start: {
            line: 310,
            column: 4
          },
          end: {
            line: 312,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 310,
            column: 4
          },
          end: {
            line: 312,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 310
      },
      "35": {
        loc: {
          start: {
            line: 313,
            column: 4
          },
          end: {
            line: 315,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 313,
            column: 4
          },
          end: {
            line: 315,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 313
      },
      "36": {
        loc: {
          start: {
            line: 321,
            column: 4
          },
          end: {
            line: 323,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 321,
            column: 4
          },
          end: {
            line: 323,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 321
      },
      "37": {
        loc: {
          start: {
            line: 324,
            column: 4
          },
          end: {
            line: 326,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 324,
            column: 4
          },
          end: {
            line: 326,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 324
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a0b917a27b6fe13385e03ad851c6dd082e2fbb93"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_z2w099oc0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_z2w099oc0();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import { jsx, keyframes } from '@emotion/react';
import { Box, Flex, Text } from '../../core';
import Responsive from '../../deprecated/UNSAFE_Responsive';
import { hex, getR, getG, getB } from '../../helpers/convertColor';
import { colors } from '../../theme/eero';
var MILESTONE_WIDTH = (cov_z2w099oc0().s[0]++, 80); // px

var MILESTONE_BORDER_IN_PROGRESS = (cov_z2w099oc0().s[1]++, 5); // px

var MILESTONE_BORDER_PENDING = (cov_z2w099oc0().s[2]++, 3); // px

var carrotAnimation = (cov_z2w099oc0().s[3]++, keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: scale(0.6);\n    opacity: 0.3;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n"]))));

var ProgressBar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ProgressBar, _React$PureComponent);

  var _super = _createSuper(ProgressBar);

  function ProgressBar() {
    _classCallCheck(this, ProgressBar);

    return _super.apply(this, arguments);
  }

  _createClass(ProgressBar, [{
    key: "render",
    value: function render() {
      var _this = this;

      cov_z2w099oc0().f[0]++;

      var _ref = (cov_z2w099oc0().s[5]++, this.props),
          carrotPositionDesktop = _ref.carrotPositionDesktop,
          carrotPositionMobile = _ref.carrotPositionMobile,
          carrotText = _ref.carrotText,
          dockPositionDesktop = _ref.dockPositionDesktop,
          dockPositionMobile = _ref.dockPositionMobile,
          milestones = _ref.milestones,
          thickness = _ref.thickness,
          backgroundColor = _ref.backgroundColor,
          progressTransitionSpeed = _ref.progressTransitionSpeed;

      var progress = (cov_z2w099oc0().s[6]++, this.getProgress());
      var colorEnd = (cov_z2w099oc0().s[7]++, this.getColor(progress));
      cov_z2w099oc0().s[8]++;

      var renderProp = function renderProp(_ref2) {
        var gtXS = _ref2.gtXS;
        cov_z2w099oc0().f[1]++;
        cov_z2w099oc0().s[9]++;
        return _this.renderCarrot(carrotText, carrotPositionDesktop, carrotPositionMobile, gtXS);
      }; // adjust width for milestones at either end


      var widthAdjustment = (cov_z2w099oc0().s[10]++, 0);
      cov_z2w099oc0().s[11]++;

      if (milestones) {
        cov_z2w099oc0().b[0][0]++;
        cov_z2w099oc0().s[12]++;
        widthAdjustment = milestones.filter(function (m) {
          cov_z2w099oc0().f[2]++;
          cov_z2w099oc0().s[13]++;
          return (cov_z2w099oc0().b[1][0]++, m.completionPercentage === 0) || (cov_z2w099oc0().b[1][1]++, m.completionPercentage === 100);
        }).length * MILESTONE_WIDTH / 2;
      } else {
        cov_z2w099oc0().b[0][1]++;
      }

      cov_z2w099oc0().s[14]++;
      return jsx(Box, {
        position: [dockPositionMobile === 'below' ? (cov_z2w099oc0().b[2][0]++, 'fixed') : (cov_z2w099oc0().b[2][1]++, 'relative'), null, 'relative', dockPositionDesktop === undefined ? (cov_z2w099oc0().b[3][0]++, 'relative') : (cov_z2w099oc0().b[3][1]++, 'fixed')],
        top: [null, null, null, dockPositionDesktop === 'above' ? (cov_z2w099oc0().b[4][0]++, 0) : (cov_z2w099oc0().b[4][1]++, 'initial')],
        bottom: [dockPositionMobile === 'below' ? (cov_z2w099oc0().b[5][0]++, 0) : (cov_z2w099oc0().b[5][1]++, 'initial'), null, 'initial', dockPositionDesktop === 'below' ? (cov_z2w099oc0().b[6][0]++, 0) : (cov_z2w099oc0().b[6][1]++, 'initial')],
        margin: "auto",
        width: "calc(100% - ".concat(widthAdjustment, "px)"),
        zIndex: 5
      }, (cov_z2w099oc0().b[7][0]++, carrotText) && (cov_z2w099oc0().b[7][1]++, jsx(Responsive, {
        render: renderProp
      })), jsx(Box, {
        "data-testid": "progressbar-background",
        position: "relative",
        overflow: "hidden",
        backgroundColor: backgroundColor,
        height: "".concat(thickness, "px") // @ts-expect-error Overriding border radius to custom widths
        ,
        borderRadius: "".concat(thickness, "px")
      }, jsx(Box, {
        width: "".concat(progress, "%"),
        height: "100%",
        background: "linear-gradient(to right, ".concat(this.props.colorStart, " 0%, ").concat(colorEnd, " 100%)") // @ts-expect-error Overriding border radius to custom widths
        ,
        borderBottomRightRadius: "".concat(thickness, "px") // @ts-expect-error Overriding border radius to custom widths
        ,
        borderTopRightRadius: "".concat(thickness, "px"),
        transition: "width ".concat(progressTransitionSpeed, "s"),
        "aria-current": "step"
      })), (cov_z2w099oc0().b[8][0]++, milestones) && (cov_z2w099oc0().b[8][1]++, this.renderMilestones()));
    }
  }, {
    key: "getProgress",
    value: function getProgress() {
      cov_z2w099oc0().f[3]++;

      var _ref3 = (cov_z2w099oc0().s[15]++, this.props),
          progress = _ref3.progress;

      cov_z2w099oc0().s[16]++;
      return progress > 100 ? (cov_z2w099oc0().b[9][0]++, 100) : (cov_z2w099oc0().b[9][1]++, progress < 0 ? (cov_z2w099oc0().b[10][0]++, 0) : (cov_z2w099oc0().b[10][1]++, progress));
    }
  }, {
    key: "renderCarrot",
    value: function renderCarrot(carrotText, carrotPositionDesktop, carrotPositionMobile, gtXS) {
      cov_z2w099oc0().f[4]++;

      var _ref4 = (cov_z2w099oc0().s[17]++, this.props),
          carrotTextBold = _ref4.carrotTextBold,
          carrotBorderRadius = _ref4.carrotBorderRadius,
          carrotColorOverride = _ref4.carrotColorOverride,
          carrotPositionOverride = _ref4.carrotPositionOverride;

      var progress = (cov_z2w099oc0().s[18]++, this.getProgress());
      var carrotColor = (cov_z2w099oc0().s[19]++, (cov_z2w099oc0().b[11][0]++, carrotColorOverride) || (cov_z2w099oc0().b[11][1]++, this.getColor(progress)));
      var carrotMargin = (cov_z2w099oc0().s[20]++, 30); // in px

      var maxMobileProgressPercent = (cov_z2w099oc0().s[21]++, 83); // upper limit to keep top right corner clear

      var maxDesktopProgressPercent = (cov_z2w099oc0().s[22]++, 95); // upper limit to avoid horizontal scrolling

      var left = (cov_z2w099oc0().s[23]++, "".concat((cov_z2w099oc0().b[12][0]++, carrotPositionOverride) || (cov_z2w099oc0().b[12][1]++, progress), "%"));
      var right = (cov_z2w099oc0().s[24]++, 'initial');
      var transform = (cov_z2w099oc0().s[25]++, 'translateX(-50%)');
      cov_z2w099oc0().s[26]++;

      if (!carrotPositionOverride) {
        cov_z2w099oc0().b[13][0]++;
        cov_z2w099oc0().s[27]++;

        if (progress < 20) {
          cov_z2w099oc0().b[14][0]++;
          cov_z2w099oc0().s[28]++;
          left = "".concat(progress, "%");
          cov_z2w099oc0().s[29]++;
          transform = "translateX(-".concat(carrotMargin, "px)");
        } else {
          cov_z2w099oc0().b[14][1]++;
          cov_z2w099oc0().s[30]++;

          if (progress > 80) {
            cov_z2w099oc0().b[15][0]++;
            cov_z2w099oc0().s[31]++;
            left = 'initial';
            cov_z2w099oc0().s[32]++;
            right = "".concat(100 - _min([progress, gtXS ? (cov_z2w099oc0().b[16][0]++, maxDesktopProgressPercent) : (cov_z2w099oc0().b[16][1]++, maxMobileProgressPercent)]), "%");
            cov_z2w099oc0().s[33]++;
            transform = "translateX(".concat(carrotMargin, "px)");
          } else {
            cov_z2w099oc0().b[15][1]++;
          }
        }
      } else {
        cov_z2w099oc0().b[13][1]++;
      }

      var carrotAboveDesktop = (cov_z2w099oc0().s[34]++, carrotPositionDesktop === 'above');
      var carrotAboveMobile = (cov_z2w099oc0().s[35]++, carrotPositionMobile === 'above');
      var carrotAbove = (cov_z2w099oc0().s[36]++, gtXS ? (cov_z2w099oc0().b[17][0]++, carrotAboveDesktop) : (cov_z2w099oc0().b[17][1]++, carrotAboveMobile));
      cov_z2w099oc0().s[37]++;
      return jsx(Box, {
        "data-testid": "progressbar-carrot",
        animation: "".concat(carrotAnimation, " 0.5s")
      }, jsx(Text, {
        position: "absolute",
        p: "5px 10px",
        background: carrotColor,
        color: "neutrals0",
        fontSize: "s00",
        fontWeight: carrotTextBold ? (cov_z2w099oc0().b[18][0]++, 'bolder') : (cov_z2w099oc0().b[18][1]++, 'normal') // @ts-expect-error Overriding border radius to custom widths
        ,
        borderRadius: "".concat(carrotBorderRadius, "px"),
        boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.3)",
        top: carrotAbove ? (cov_z2w099oc0().b[19][0]++, '-45px') : (cov_z2w099oc0().b[19][1]++, '18px'),
        left: left,
        right: right,
        transform: transform,
        style: {
          whiteSpace: 'nowrap'
        }
      }, carrotText), jsx(Box, {
        position: "absolute",
        width: 0,
        height: 0,
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        borderTop: "8px solid" // @ts-expect-error String color value is passed in rather than design system token
        ,
        borderTopColor: carrotColor,
        transform: !carrotAbove ? (cov_z2w099oc0().b[20][0]++, 'translateX(-50%) scale(-1)') : (cov_z2w099oc0().b[20][1]++, 'translateX(-50%)'),
        top: carrotAbove ? (cov_z2w099oc0().b[21][0]++, '-18px') : (cov_z2w099oc0().b[21][1]++, '10px'),
        left: "".concat((cov_z2w099oc0().b[22][0]++, carrotPositionOverride) || (cov_z2w099oc0().b[22][1]++, progress), "%")
      }));
    }
  }, {
    key: "renderMilestones",
    value: function renderMilestones() {
      var _this2 = this;

      cov_z2w099oc0().f[5]++;

      var _ref5 = (cov_z2w099oc0().s[38]++, this.props),
          milestones = _ref5.milestones,
          onSelectMilestone = _ref5.onSelectMilestone,
          thickness = _ref5.thickness,
          carrotPositionOverride = _ref5.carrotPositionOverride,
          carrotColorOverride = _ref5.carrotColorOverride;

      cov_z2w099oc0().s[39]++;
      return jsx(Box, {
        mt: "-".concat(this.getDotSize() / 2 + thickness / 2, "px"),
        position: "relative",
        width: "100%"
      }, _map(milestones, function (milestone, i) {
        cov_z2w099oc0().f[6]++;
        var status = (cov_z2w099oc0().s[40]++, _this2.getMilestoneStatus(milestone));
        cov_z2w099oc0().s[41]++;
        return jsx(Flex, {
          key: i,
          position: "absolute",
          width: "".concat(MILESTONE_WIDTH, "px"),
          left: "calc(".concat(milestone.completionPercentage, "% - ").concat(MILESTONE_WIDTH / 2, "px)"),
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          cursor: onSelectMilestone ? (cov_z2w099oc0().b[23][0]++, 'pointer') : (cov_z2w099oc0().b[23][1]++, 'initial'),
          onClick: onSelectMilestone ? (cov_z2w099oc0().b[24][0]++, function () {
            cov_z2w099oc0().f[7]++;
            cov_z2w099oc0().s[42]++;
            return onSelectMilestone(milestone);
          }) : (cov_z2w099oc0().b[24][1]++, undefined)
        }, jsx(Box, {
          borderStyle: "solid" // @ts-expect-error Overriding border radius to custom widths
          ,
          borderRadius: "".concat(_this2.getDotSize(), "px"),
          background: carrotPositionOverride ? (cov_z2w099oc0().b[25][0]++, (cov_z2w099oc0().b[26][0]++, carrotColorOverride) || (cov_z2w099oc0().b[26][1]++, _this2.getColor(milestone.completionPercentage))) : (cov_z2w099oc0().b[25][1]++, status === 'completed' ? (cov_z2w099oc0().b[27][0]++, _this2.getColor(milestone.completionPercentage)) : (cov_z2w099oc0().b[27][1]++, 'neutrals0')) // @ts-expect-error String color value is passed in rather than design system token
          ,
          borderColor: carrotPositionOverride ? (cov_z2w099oc0().b[28][0]++, 'neutrals0') : (cov_z2w099oc0().b[28][1]++, status === 'pending' ? (cov_z2w099oc0().b[29][0]++, 'neutrals30') : (cov_z2w099oc0().b[29][1]++, _this2.getColor(milestone.completionPercentage))),
          borderWidth: "".concat(carrotPositionOverride ? (cov_z2w099oc0().b[30][0]++, MILESTONE_BORDER_IN_PROGRESS) : (cov_z2w099oc0().b[30][1]++, _this2.getDotBorderSize(milestone)), "px"),
          height: "".concat(_this2.getDotSize(), "px"),
          width: "".concat(_this2.getDotSize(), "px")
        }), jsx(Box, {
          mt: 2,
          fontSize: "s00",
          color: status === 'in-progress' ? (cov_z2w099oc0().b[31][0]++, 'brand50') : (cov_z2w099oc0().b[31][1]++, 'neutrals70')
        }, milestone.label));
      }));
    }
  }, {
    key: "getColor",
    value: function getColor(percentage) {
      cov_z2w099oc0().f[8]++;

      var _ref6 = (cov_z2w099oc0().s[43]++, this.props),
          gradientProgress = _ref6.gradientProgress,
          colorEnd = _ref6.colorEnd;

      cov_z2w099oc0().s[44]++;

      if (!gradientProgress) {
        cov_z2w099oc0().b[32][0]++;
        cov_z2w099oc0().s[45]++;
        return this.props.colorStart;
      } else {
        cov_z2w099oc0().b[32][1]++;
      }

      var ratio = (cov_z2w099oc0().s[46]++, percentage / 100.0);
      var r = (cov_z2w099oc0().s[47]++, Math.ceil(getR(this.props.colorStart) * (1 - ratio) + getR(colorEnd) * ratio));
      var g = (cov_z2w099oc0().s[48]++, Math.ceil(getG(this.props.colorStart) * (1 - ratio) + getG(colorEnd) * ratio));
      var b = (cov_z2w099oc0().s[49]++, Math.ceil(getB(this.props.colorStart) * (1 - ratio) + getB(colorEnd) * ratio));
      cov_z2w099oc0().s[50]++;
      return '#' + hex(r) + hex(g) + hex(b);
    }
  }, {
    key: "getDotSize",
    value: function getDotSize() {
      cov_z2w099oc0().f[9]++;
      var calculatedSize = (cov_z2w099oc0().s[51]++, this.props.thickness * 2);
      var minSize = (cov_z2w099oc0().s[52]++, 20);
      var dotSize = (cov_z2w099oc0().s[53]++, calculatedSize > minSize ? (cov_z2w099oc0().b[33][0]++, calculatedSize) : (cov_z2w099oc0().b[33][1]++, minSize));
      cov_z2w099oc0().s[54]++;
      return dotSize;
    }
  }, {
    key: "getDotBorderSize",
    value: function getDotBorderSize(milestone) {
      cov_z2w099oc0().f[10]++;
      var status = (cov_z2w099oc0().s[55]++, this.getMilestoneStatus(milestone));
      cov_z2w099oc0().s[56]++;

      if (status === 'in-progress') {
        cov_z2w099oc0().b[34][0]++;
        cov_z2w099oc0().s[57]++;
        return MILESTONE_BORDER_IN_PROGRESS;
      } else {
        cov_z2w099oc0().b[34][1]++;
      }

      cov_z2w099oc0().s[58]++;

      if (status === 'pending') {
        cov_z2w099oc0().b[35][0]++;
        cov_z2w099oc0().s[59]++;
        return MILESTONE_BORDER_PENDING;
      } else {
        cov_z2w099oc0().b[35][1]++;
      }

      cov_z2w099oc0().s[60]++;
      return 0;
    }
  }, {
    key: "getMilestoneStatus",
    value: function getMilestoneStatus(milestone) {
      cov_z2w099oc0().f[11]++;

      var _ref7 = (cov_z2w099oc0().s[61]++, this.props),
          progress = _ref7.progress;

      cov_z2w099oc0().s[62]++;

      if (progress > milestone.completionPercentage) {
        cov_z2w099oc0().b[36][0]++;
        cov_z2w099oc0().s[63]++;
        return 'completed';
      } else {
        cov_z2w099oc0().b[36][1]++;
      }

      cov_z2w099oc0().s[64]++;

      if (progress === milestone.completionPercentage) {
        cov_z2w099oc0().b[37][0]++;
        cov_z2w099oc0().s[65]++;
        return 'in-progress';
      } else {
        cov_z2w099oc0().b[37][1]++;
      }

      cov_z2w099oc0().s[66]++;
      return 'pending';
    }
  }]);

  return ProgressBar;
}((React.PureComponent));

_defineProperty(ProgressBar, "defaultProps", (cov_z2w099oc0().s[4]++, {
  carrotPositionDesktop: 'above',
  carrotPositionMobile: 'below',
  carrotBorderRadius: 3,
  gradientProgress: true,
  thickness: 8,
  colorStart: colors.brand50,
  colorEnd: colors.green50,
  backgroundColor: 'blue30',
  progressTransitionSpeed: 0.5
}));

export default ProgressBar;